import { getCookie } from './cookies';
import { getCsrfToken } from '../lib/apiClient';
import { reportSessionExpired } from './sessionExpiry';

const NON_SAFE_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

// Обёртка над fetch:
// - всегда отправляет cookies (`credentials: 'include'`)
// - для не-GET методов добавляет заголовок `X-CSRFToken`: из cookie `csrftoken` (веб),
//   а если cookie недоступна (desktop-EXE на file://) — из памяти apiClient (тело /api/csrf/).
// Пользовательские опции (включая собственный заголовок X-CSRFToken и credentials) имеют приоритет.
export const csrfFetch = (input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> => {
  const method = (init.method || 'GET').toUpperCase();
  const headers = new Headers(init.headers || {});
  if (NON_SAFE_METHODS.has(method) && !headers.has('X-CSRFToken')) {
    const token = getCookie('csrftoken') || getCsrfToken();
    if (token) headers.set('X-CSRFToken', token);
  }
  return fetch(input, {
    ...init,
    credentials: init.credentials ?? 'include',
    headers,
  }).then((res) => {
    // Истёкшая сессия: глобальный репорт (AuthContext сбросит isAuthenticated,
    // поллеры/стримы остановятся). /api/login/ — там 401 = неверный пароль.
    if (res.status === 401 && !String(input).includes('/api/login')) {
      reportSessionExpired('csrfFetch:' + String(input).slice(0, 80));
    }
    return res;
  });
};
